import { Component, h, ComponentInterface, State, Prop } from '@stencil/core';
import { guid } from 'utils';

@Component({
	tag: 'kdx-basic-hero',
	styleUrl: 'kdx-basic-hero.scss',
	shadow: false
})
export class StBasicHero implements ComponentInterface {
  
	@State() guid: string = guid();

	@Prop() ariaLabel: string = 'A default label';
	@Prop() imgSrc: string;
	@Prop() imgAlt: string;
	@Prop() componentScope: string = "kdx";
	@Prop() headerStyle: string;
	@Prop() btnText: string;
	@Prop() btnHref: string;
	@Prop() btnAlt: string;
	@Prop() btnTarget: string;
	@Prop() isSpeedbump: boolean;
	
	render() {
		return (
			<section class={`kdx-basic-hero${this.componentScope ? ` ${this.componentScope}-basic-hero`: ''} ${this.headerStyle ? this.headerStyle : ""}`} id={`kdx-basic-hero-${this.guid}`} aria-label={this.ariaLabel}>
				{this.imgSrc &&
					<div class="bg-image" role="presentation" style={{backgroundImage: `url(${this.imgSrc}`}}></div>
				}
				<div class="container-fluid">
					<div class="row">
						<div class={`${this.btnHref ? "col-md-9" : "col-12"}`}>
							<slot />
						</div>
						{this.btnHref && this.btnHref != "" &&
							<div class="col-md-3">
								<div class="cta">
									<a 
									href={this.btnHref} 
									class={`btn btn-secondary ${this.isSpeedbump ? "speedbump-link" : ""}`} 
									target={this.btnTarget ? this.btnTarget : "_self"} 
									aria-label={this.btnAlt}
									>
										{this.btnText}
									</a>
								</div>
							</div>
						}
					</div>
				</div>
			</section>
		);
	}
}